import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Handles scroll on navigation:
// - With a hash (e.g. /#work) → smoothly scroll to that section via Lenis.
//   When arriving from another route, jump instantly so we land on the section
//   (the carousel of work) instead of animating past the hero.
// - Without a hash on a route change → reset to the top.
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  const prevPath = useRef(pathname);

  useEffect(() => {
    const changedRoute = prevPath.current !== pathname;
    prevPath.current = pathname;

    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const scrollToEl = (el) => {
        if (window.__lenis) {
          // Recompute Lenis' scroll limit first — the work gallery grows the page
          // after mount, and a stale limit would clamp the target short.
          if (window.__lenis.resize) window.__lenis.resize();
          window.__lenis.scrollTo(el, { offset: -100, immediate: changedRoute, duration: 1.1 });
        } else {
          el.scrollIntoView({ behavior: changedRoute ? "auto" : "smooth" });
        }
      };
      let tries = 0;
      const go = () => {
        const el = document.getElementById(id);
        if (el) {
          scrollToEl(el);
          // The work gallery measures its width after mount and grows the page,
          // shifting sections below it. Re-correct once layout has settled.
          if (changedRoute) {
            setTimeout(() => scrollToEl(el), 260);
            setTimeout(() => scrollToEl(el), 650);
          }
        } else if (tries++ < 30) {
          setTimeout(go, 40);
        }
      };
      setTimeout(go, changedRoute ? 90 : 0);
    } else if (changedRoute) {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, key]);

  return null;
}
